export const hasAbilities = (userAbilities: string[], allowedAbilities: string[]) => {
  if (allowedAbilities.length === 0) return true;

  return userAbilities?.some((ability) => allowedAbilities.includes(ability));
};
